import React from 'react';
import Complete from './Complete';
import connectToStores from 'alt-utils/lib/connectToStores';
import AuthStore from 'stores/AuthStore';
import EditComplete from 'components/coaching/wizard/steps/EditComplete';

class CompleteContainer extends React.PureComponent {
  static getStores() {
    return [AuthStore];
  }

  static getPropsFromStores() {
    return {
      sessionUser: AuthStore.getState().user,
    };
  }

  render() {
    if (this.props.editMode) {
      return <EditComplete {...this.props} />;
    } else {
      return <Complete {...this.props} />;
    }
  }
}

export default connectToStores(CompleteContainer);
